import { useSyncExternalStore } from "react";

import {
  getPreferences,
  type Preferences,
  setPreference,
  subscribeToPreferences,
} from "src/lib/preferencesCookie";

export function usePreference<TKey extends keyof Preferences>(key: TKey) {
  function getValue() {
    return getPreferences()[key];
  }

  const value = useSyncExternalStore(
    subscribeToPreferences,
    getValue,
    getValue,
  );

  function setValue(nextValue: Preferences[TKey]) {
    setPreference(key, nextValue);
  }

  return [value, setValue] as const;
}
